module.exports = __webpack_public_path__ + "images/emoji/arrow_double_down.ae80c29420dd33cd60d5.png";